import { InvoiceV2OpenApi } from "queries/InvoiceV2Open";
import React from "react";

interface Props {
  secret: string
}

const ViewDocumentInline = (props: Props) => {
  const scrollbarWidth = getScrollbarWidth();
  const margin = 8 * 2; // the a4 has a 8px margin on each side
  const documentPreviewApi = InvoiceV2OpenApi.PreviewDocument.useQuery(props.secret, {});

  return <div className="document-inline-panel" style={{
    height: "calc(100vh - 144px)",
    minHeight: "297mm",
    width: `calc(210mm + ${scrollbarWidth + margin}px)`,

  }}>
    <iframe width="100%" height="100%" style={{ backgroundColor: "white" }} srcDoc={documentPreviewApi.data?.data} />
  </div>;
};

function getScrollbarWidth() {
  // Create a temporary div with forced scrollbars
  const div = document.createElement("div");
  div.style.visibility = "hidden";
  div.style.overflow = "scroll";
  div.style.width = "100px";
  div.style.position = "absolute";
  document.body.appendChild(div);

  // Add an inner element to measure the difference
  const inner = document.createElement("div");
  inner.style.width = "100%";
  div.appendChild(inner);

  const scrollbarWidth = div.offsetWidth - inner.offsetWidth;

  // Clean up
  div.remove();

  return scrollbarWidth;
}

export default ViewDocumentInline;